import React from "react";
import { Box } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";

import ServiceUnavailableDialog from "./ServiceUnavailableDialog";
import { SERVICE_UNAVAILABLE_PATH } from "../../utils/serviceUnavailableRedirect";

/**
 * On `/service-unavailable`, blur the rendered route (dashboard) and show the downtime dialog.
 */
export default function ServiceUnavailableGate({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement {
  const location = useLocation();
  const pathname = location.pathname.replace(/\/+$/, "") || "/";

  if (pathname !== SERVICE_UNAVAILABLE_PATH) {
    return <>{children}</>;
  }

  return (
    <Box position="relative" minH="100%">
      <Box
        filter="blur(7px)"
        pointerEvents="none"
        userSelect="none"
        opacity={0.92}
        transition="filter 0.2s ease"
        aria-hidden
      >
        {children}
      </Box>
      <ServiceUnavailableDialog isOpen />
    </Box>
  );
}
